import {
  Col,
  Input,
  Row,
  Spin,
  Tooltip,
} from "../../../components/common/utils/antd-imports/AntdImports";
import "./RfpRequests.css";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getRfpRequests } from "../../../store/thunks/seller-thunks/SellerThunk";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { formatToUSCurrency } from "../../../components/common/utils/Utils";
import { ReactComponent as SearchIcon } from "../../../assests/search-icon.svg";
import EmptyViewCard from "../../../components/common/empty-view-card/EmptyViewCard";
import "../../../main.css";
import BreadcrumbNav from "../../../components/common/bread-crumbs/BreadCrumb";
import { addBreadcrumb } from "../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice";

const RfpRequests = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 425 });
  const { rfpList, isLoading } = useSelector((state) => state.rfp);
  const [filteredList, setFilteredList] = useState(rfpList);

  const dispatch = useDispatch();

  const CAMPAIGN_STATUS = {
    "campaign-preparing": 100,
    "campaign-created": 200,
    "quote-requested": 300,
    "quote-given": 400,
    "change-requested": 500,
    "booking-requested": 600,
    scheduled: 700,
    running: 800,
    suspended: 900,
    stopped: 1000,
    "deleted-cancelled": 1200,
    "rfp-campaign": 1300,
    "metro-campaign-created": 1101,
    "metro-campaign-checked-out": 1121,
    "metro-campaign-locked": 1131,
    "metro-campaign-running": 1141,
    "metro-campaign-stopped": 1151,
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return "Invalid date";
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const parts = timestamp.split("-");
    if (parts.length !== 3) return "Invalid date format";
    const [year, month, day] = parts;
    return `${parseInt(day)} ${months[parseInt(month) - 1]} ${year}`;
  };

  const convertStatusToLabel = (campaigns) => {
    const statusMap = Object.fromEntries(
      Object.entries(CAMPAIGN_STATUS)?.map(([label, value]) => [value, label]),
    );
    return campaigns?.map((campaign) => ({
      ...campaign,
      status: statusMap[campaign?.status] || "",
    }));
  };

  const formatBrandGoal = (brandGoal) => {
    if (!brandGoal || (Array.isArray(brandGoal) && brandGoal.length === 0)) {
      return "-";
    }
    if (Array.isArray(brandGoal)) {
      return brandGoal.join(", ");
    }
    return brandGoal?.toString();
  };
  useEffect(() => {
    dispatch(getRfpRequests());
  }, [dispatch]);

  const navigateCampaignDetails = (record) => {
    dispatch(
      addBreadcrumb({
        title: record?.name,
        path: `/buyer/campaigndetails?_id=${btoa(record?.id)}`,
      }),
    );
    navigate(`/seller/viewCampaigns/campaignDetails/${btoa(record.id)}`);
  };
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (searchText === "") {
      return setFilteredList(rfpList);
    } else {
      const filtered = Object.values(rfpList)?.filter(
        (campaign) =>
          campaign.cid?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
          campaign.name?.toLowerCase()?.includes(searchText?.toLowerCase()),
      );
      return setFilteredList(filtered);
    }
  }, [searchText]);

  return (
    <div className="seller-rfp-main-div">
      <div className="rfp-bread-crumb">
        <BreadcrumbNav />
      </div>
      <Row className="seller-rfp-heading-div main-title-size">
        <span style={{ fontFamily: "Montserrat" }}>
          Requests For Proposal (RFPs) Matching Your Products
        </span>
        <Col xl={10} lg={11} md={10} sm={24} className="rfp-search">
          <Input
            allowClear
            prefix={<SearchIcon />}
            className="view-campaign-search common-search"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search by campaign name, id..."
          />
        </Col>
      </Row>
      <div className="seller-rfp-div">
        {(
          filteredList
            ? Object.values(filteredList)?.length > 0
            : rfpList && Object.values(rfpList)?.length > 0
        ) ? (
          <div className="seller-rfp-list-main-div">
            {(filteredList && filteredList.length > 0
              ? convertStatusToLabel(Object.values(filteredList))
              : convertStatusToLabel(Object.values(rfpList))
            )?.map((rfp, index) => (
              <Row
                key={index}
                style={{ height: "100%" }}
                className="seller-rfp-list-div"
                onClick={() => navigateCampaignDetails(rfp)}
              >
                <Row className="seller-rfp-list-row">
                  <div className="seller-rfp-status seller-rfp-text">
                    {rfp?.status ? rfp?.status : "-"}
                  </div>
                </Row>
                <Row className="rfp-requests-row" gutter={[32, 16]}>
                  {/* LEFT COLUMN */}
                  <Col xs={24} md={8}>
                    <div className="seller-rfp-col">
                      <span className="seller-rfp-headers">Campaign ID</span>
                      <Tooltip title={rfp?.cid || "-"}>
                        <span
                          className={`seller-rfp-text ${!isMobile ? "truncate" : ""}`}
                        >
                          {rfp?.cid || "-"}
                        </span>
                      </Tooltip>
                    </div>

                    <div className="seller-rfp-col">
                      <span className="seller-rfp-headers">Brand Goal</span>
                      <Tooltip
                        title={formatBrandGoal(rfp?.rfp_details?.brand_goal)}
                      >
                        <span
                          className={`seller-rfp-text ${!isMobile ? "truncate" : ""}`}
                        >
                          {formatBrandGoal(rfp?.rfp_details?.brand_goal)}
                        </span>
                      </Tooltip>
                    </div>

                    <div className="seller-rfp-col">
                      <span className="seller-rfp-headers">Business Goal</span>
                      <span className="seller-rfp-text">
                        {formatBrandGoal(rfp?.rfp_details?.business_goal)}
                      </span>
                    </div>
                  </Col>

                  {/* MIDDLE COLUMN */}
                  <Col xs={24} md={8}>
                    <div className="seller-rfp-col">
                      <span className="seller-rfp-headers">Campaign Name</span>
                      <Tooltip title={rfp?.name || "-"}>
                        <span
                          className={`seller-rfp-text ${!isMobile ? "truncate" : ""}`}
                        >
                          {rfp?.name || "-"}
                        </span>
                      </Tooltip>
                    </div>

                    <div className="seller-rfp-col">
                      <span className="seller-rfp-headers">DMA</span>
                      <span className="seller-rfp-text">
                        {rfp?.area_rfp_details?.[0]?.city_name || "-"}
                      </span>
                    </div>

                    <div className="seller-rfp-col">
                      <span className="seller-rfp-headers">
                        Preferred Dates
                      </span>
                      <span className="seller-rfp-text">
                        {rfp?.rfp_details?.dma_dates?.[0]
                          ? rfp.rfp_details.dma_dates[0]
                              .split("::")
                              .map((d) => formatDate(d))
                              .join(" - ")
                          : "-"}
                      </span>
                    </div>
                  </Col>

                  {/* RIGHT COLUMN */}
                  <Col xs={24} md={8}>
                    <div className="seller-rfp-col">
                      <span className="seller-rfp-headers">Email</span>
                      <Tooltip title={rfp?.user_email || "-"}>
                        <span
                          className={`seller-rfp-text ${!isMobile ? "truncate" : "email-wrap"}`}
                        >
                          {rfp?.user_email || "-"}
                        </span>
                      </Tooltip>
                    </div>

                    <div className="seller-rfp-col">
                      <span className="seller-rfp-headers">Budget Range</span>
                      <span className="seller-rfp-text">
                        {rfp?.rfp_details?.est_budget_from != null &&
                        rfp?.rfp_details?.est_budget_to != null
                          ? `${formatToUSCurrency(
                              rfp.rfp_details.est_budget_from,
                            )} - ${formatToUSCurrency(
                              rfp.rfp_details.est_budget_to,
                            )}`
                          : "-"}
                      </span>
                    </div>
                  </Col>
                </Row>
              </Row>
            ))}
          </div>
        ) : (
          <div>
            <EmptyViewCard
              header={"Matching RFPs..."}
              text={
                "Looks like there aren’t any requests matching your products right now. But don’t worry—new opportunities are always coming in! Stay tuned and keep your listings"
              }
            />
          </div>
        )}
      </div>
      {isLoading && (
        <div className="loading-css">
          <Spin size="large" fullscreen />
        </div>
      )}
    </div>
  );
};

export default RfpRequests;
